<div class="container">
   <div class="title-container">
    <p class="title">
      Sailing Performance 
      <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial Performance<mat-icon class="titleIcon">chevron_right</mat-icon>My Request
    </p>
    <mat-icon class="filter-top-btn" (click)="isFilterOpen = true" matTooltip="Table Filter">filter_list</mat-icon>
  </div>
  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter">
      <!-- Header -->
      <div class="filter-header">
        <span>Filters</span>
        <mat-icon class="close-btn" (click)="isFilterOpen = false">close</mat-icon>
      </div>

      <!-- Body -->
      <form [formGroup]="retriveForm" class="filter-body">
        <div class="filter-section">
          <h4>Date Range</h4>
          <app-custom-date-picker
            [label]="'From:'"
            [controlname]="retriveForm.controls['cosp']"
          ></app-custom-date-picker>

          <app-custom-date-picker
            [label]="'To:'"
            [controlname]="retriveForm.controls['eosp']"
          ></app-custom-date-picker>
        </div>

        <div class="filter-section">
          <h4>Requesters</h4>
          <app-custom-dropdown
            [placeholder]="'ALL'"
            [label]="'Requesters'"
            [items]="requestersOptions"
            [controlname]="retriveForm.controls['requesters']"
          ></app-custom-dropdown>
        </div>

        <div class="filter-section">
          <h4>Vessel Details</h4>
          <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">Ship Name</label>
          <input
            type="text"
            class="form-control shipName"
            id="shipName"
            formControlName="shipName"
            (input)="filterShipNames($event)"
            [matAutocomplete]="autoShip"
          />
          <mat-autocomplete #autoShip="matAutocomplete">
            <mat-option *ngFor="let ship of shipNameSuggestions" [value]="ship.ship">
              {{ ship.ship }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </form>

      <!-- Footer Buttons -->
      <div class="filter-footer">
        <button class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear
        </button>
        <button class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply
        </button>
      </div>
    </div>
  </div>

  <div class="table-container scroll-bar">
  <table
    class="mat-elevation-z8"
    id="style-4"
    matSort
    [ngClass]="{ 'dark-table': isDarkMode() }"
  >
    <thead>
      <tr>
        <th class="th-text-center" mat-sort-header="sNo">S.No</th>
        <th>Vessel Name</th>
        <th class="th-text-center" mat-sort-header="cosp">Cosp</th>
        <th class="th-text-center" mat-sort-header="eosp">Eosp</th>
        <th
          class="th-text-center1"
          mat-sort-header="segment"
          *ngIf="userName !== 'Zeronorth ZN'"
        >
          Segment
        </th>
        <th
          class="th-text-center1"
          mat-sort-header="merakiPic"
          *ngIf="userName !== 'Zeronorth ZN'"
        >
          MerakiPic
        </th>
        <th
          *ngIf="
            userName === 'Meraki - Operations' || userName === 'Zeronorth ZN'
          "
        >
          OpenForm
        </th>
        <th>Mid Voyage Report</th>
        <th>End Voyage Report</th>
      </tr>
    </thead>
    <tbody>
      <!-- Skeleton Loaders -->
      <ng-container *ngIf="isLoading">
        <tr *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
          <td><div class="skeleton skeleton-text short"></div></td>
          <td><div class="skeleton skeleton-text"></div></td>
          <td><div class="skeleton skeleton-text"></div></td>
          <td><div class="skeleton skeleton-text"></div></td>
          <td *ngIf="userName !== 'Zeronorth ZN'">
            <div class="skeleton skeleton-badge"></div>
          </td>
          <td *ngIf="userName !== 'Zeronorth ZN'">
            <div class="skeleton skeleton-text"></div>
          </td>
          <td *ngIf="userName === 'Meraki - Operations' || userName === 'Zeronorth ZN'">
            <div class="skeleton skeleton-btn"></div>
          </td>
          <td><div class="skeleton skeleton-icon"></div></td>
          <td><div class="skeleton skeleton-icon"></div></td>
        </tr>
      </ng-container>

      <!-- Real Data Rows -->
      <ng-container *ngIf="!isLoading">
        <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td>{{ rowIndex + 1 }}</td>
          <td>{{ removeShipPrefix(element.ship) }}</td>
          <td>{{ element.cosp !== "null" ? element.cosp : "" }}</td>
          <td>{{ element.eosp !== "null" ? element.eosp : "" }}</td>
          <td *ngIf="userName !== 'Zeronorth ZN'">
            <span [ngStyle]="getDynamicSegmentStyle(element.normalizedSegment)">
              {{ element.normalizedSegment }}
            </span>
          </td>
          <td *ngIf="userName !== 'Zeronorth ZN'">{{ element.merakiPic }}</td>
          <td *ngIf="userName === 'Meraki - Operations' || userName === 'Zeronorth ZN'">
            <button
              class="gradient-btn"
              [ngStyle]="{
                'background-image': 'linear-gradient(98deg, #0046de, #006063)',
                'border-radius': '11px',
                border: 'none'
              }"
              (click)="showDetails(element)"
              [disabled]="element.status === 'True'"
            >
              <mat-icon
                fontSet="material-icons-outlined"
                fontIcon="visibility"
                class="visiblityIcon"
                >visibility_outlined</mat-icon
              >
            </button>
          </td>
          <td>
            <button
              class="downloadIcon"
              (click)="download(element)"
              *ngIf="element.mvr_pdflink"
            >
              <mat-icon>download</mat-icon>
            </button>
            <mat-icon
              [matTooltip]="getErrorMessage(element)"
              matTooltipClass="custom-tooltip"
              class="error"
              (click)="download(element)"
              *ngIf="
                !element.mvr_pdflink &&
                !element.evr_pdflink &&
                element.error_id &&
                element.reportType === 'MID'
              "
              >error</mat-icon
            >
          </td>
          <td>
            <button
              class="downloadIcon"
              (click)="download(element)"
              *ngIf="element.evr_pdflink"
            >
              <mat-icon>download</mat-icon>
            </button>
            <mat-icon
              [matTooltip]="getErrorMessage(element)"
              matTooltipClass="custom-tooltip"
              class="error"
              (click)="download(element)"
              *ngIf="
                !element.mvr_pdflink &&
                !element.evr_pdflink &&
                element.error_id &&
                element.reportType === 'END'
              "
              >error</mat-icon
            >
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
  <mat-paginator
    [length]="RetriveData.length"
    [pageSizeOptions]="[100]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
    showFirstLastButtons
  ></mat-paginator>
  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="exportClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>
</div>
